module.exports = __webpack_public_path__ + "img/storico-istanze.11ffb416.jpg";